import { FC } from "react";
import { useTranslation } from "react-i18next";

import { IconDashesHorizontal } from "@/components/_icons/IconDashesHorizontal";
import { TruncatedText } from "@/components/_molecules/truncated-text/truncated-text";
import { cn } from "@/lib/cn";

interface PhaseViewEmptyProps {
  logoOnly?: boolean;
  canTruncateLabel?: boolean;
  className?: string;
}

export const PhaseViewEmpty: FC<PhaseViewEmptyProps> = ({ canTruncateLabel = false, ...props }) => {
  const { t } = useTranslation("common");
  return (
    <div className={cn(["flex flex-row items-center gap-2", canTruncateLabel && "min-w-0"])}>
      <IconDashesHorizontal className={cn(["h-4 w-4 shrink-0", props.className])} />
      {!props.logoOnly && <TruncatedText text={t("notAssigned")} canTruncate={canTruncateLabel} />}
    </div>
  );
};
